import Plugin from 'src/plugin-system/plugin.class';

export default class VideoPlayPlugin extends Plugin {

    init() {

        $(this.el).find('.video-play-widget__play-button').click(() => {
            var videoSrc = $(this.el).data("src");

            if ($(this.el).find('.video-play-widget__frame').attr('src') == '') {
                $(".video-play-widget__frame").attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0" ); 
                $(this.el).find('.video-play-widget__overlay').addClass('is--visible');
            } else {
                $(this.el).find('.video-play-widget__overlay').removeClass('is--visible');
                $(".video-play-widget__frame").attr('src', ''); 
            }
            
        });
  
    }

}